<ng-content></ng-content>
<div class="image-container">
  <!-- <button class="btn primary fab sm corner-btn">+</button> -->
  @if (image?.url1x) {
    <img [src]="image?.url1x" alt="Profile image" />
  } @else {
    <div class="blank-icon" inlineSVG="/icons/icon-person-v2-current-color.svg"></div>
  }
</div>
